// extracted by mini-css-extract-plugin
export const herospace = "Herospace-module--herospace--11aCg";
export const backgroundImage = "Herospace-module--background-image--3e4_N";
export const contentBox = "Herospace-module--content-box--2A9FB";
export const content = "Herospace-module--content--2h2ll";
export const header = "Herospace-module--header--2Asya";
export const contentBoxFooter = "Herospace-module--content-box-footer--2-yln";
export const title = "Herospace-module--title--2fSU_";
export const subtitle = "Herospace-module--subtitle--30p5A";
export const infos = "Herospace-module--infos--2XGcF";
export const info = "Herospace-module--info--2xMCM";
export const footer = "Herospace-module--footer--q73t1";
export const seeAllCruisesButton = "Herospace-module--see-all-cruises-button--3oXvS";